import { useState, useEffect, useRef } from "react";

function useObserverNodeSize(targetNodeRef, disable) {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const observerRef = useRef(null);

  useEffect(() => {
    if (targetNodeRef.current && disable !== true) {
      observerRef.current?.disconnect();
      observerRef.current = new ResizeObserver(entries => {
        const { width, height } = entries[0].contentRect;
        setSize({ width, height });
      });

      observerRef.current.observe(targetNodeRef.current);

      return () => {
        observerRef.current.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetNodeRef.current, disable]);

  return {
    size,
  };
}

export default useObserverNodeSize;
